import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useGetProfileQuery } from '../generated/graphql';
import { session } from './auth';

export const useGetProfile = (skip = true) => {
  const hasToken = !!session.accessToken;
  const { identityValidated } = session;
  const { pathname } = useLocation();

  const {
    refetch,
    data,
    loading,
    error,
    ...rest
  } = useGetProfileQuery({ skip: !hasToken && skip });

  const id = parseInt(data?.profile?.id as string, 10);

  useEffect(() => {
    const inDebt = /\/deuda/.test(pathname);
    if (identityValidated && !id && !loading && !error && inDebt) {
      refetch();
    }
  }, [ loading, id, refetch, identityValidated, pathname, error ]);

  return {
    hasToken,
    identityValidated,
    refetch,
    data,
    loading,
    ...rest,
  };
};
